import React, { useContext, useRef } from 'react';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles, TextField } from '@material-ui/core';
import { commonFilter } from '../../constants/StyleConstants';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { strToDate, DATE_FORMAT } from '../../utils/DateUtils';
import SelectAcerBrag from '../../components/SelectAcerBrag';
import useActivityLogsPresenter from './ActivityLogsPresenter';
import ActivityLogsGrid from './ActivityLogsGrid';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const {
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    activityType,
    setActivityType,
    user,
    setUser,
    validateAndSearch,
    cleanFilters,
    
  } = filtersProps;


  return (
    <div className={classes.filters}>
      
      <TextField
        style={{ width: 150 }}
        margin="dense"
        id="user"
        label="Usuario"
        onChange={e => setUser(e.target.value)}
        value={user}
      />

      <CustomDatePicker2 value={dateFrom} maxDate={dateTo} label="Fecha desde" setValue={setDateFrom} />
      <CustomDatePicker2 value={dateTo} minDate={dateFrom} label="Fecha hasta" setValue={setDateTo} />
      
      <SelectAcerBrag
              
          rows={[
            { id: 'Login/Logout', name: 'Login/Logout' },
            { id: 'LogIn', name: 'Login' },
            { id: 'LogOut', name: 'Logout' },
            ]}
          value={activityType}
          setValue={setActivityType}
          selectTitle="Estado"
      />
      
      
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const CustomDatePicker2 = ({
  value,
  setValue,
  minDate,
  maxDate,
  label,
  disablePast,
  readOnly,
  disabled,
  style,
  disableMinDate,
  ...restProps
}) => {
  const handleBlur = e => {
    const dateValue = e.target.value;
    setValue(dateValue.isBlank() ? null : strToDate(dateValue));
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        style={{ width: 140, ...style }}
        disableToolbar
        disablePast={disablePast}
        disabled={disabled}
        autoOk
        variant="inline"
        format={DATE_FORMAT}
        margin="dense"
        invalidDateMessage="Fecha incorrecta"
        id={`date-picker-inline-${label}`}
        label={label || 'Fecha'}
        minDate={readOnly || minDate || disableMinDate ? minDate : undefined}
        maxDate={maxDate || undefined}
        value={value}
        onChange={() => undefined}
        onAccept={setValue}
        onBlur={!readOnly ? handleBlur : undefined}
        inputProps={{ readOnly: !!readOnly }}
        KeyboardButtonProps={{
          disabled: !!readOnly || !!disabled,
          'aria-label': 'change date',
        }}
        {...restProps}
      />
    </MuiPickersUtilsProvider>
  );
};

const ActivityLogs = () => {
  const tableRef = useRef();
  const { firstLoad, rows, loading, gridFunctions, ...filtersProps } = useActivityLogsPresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={!firstLoad}>
        <ActivityLogsGrid data={rows} loading={loading} tableRef={tableRef} {...gridFunctions} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};

export default ActivityLogs;